/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { Button, useToasts } from '@geist-ui/react'
import axios from 'axios'
import { useToken } from 'hooks'

export default function Download({ filepath, filename }) {
  const [fetching, setFetching] = useState(false)
  const [error, setError] = useState(false)
  const [toast, setToast] = useToasts()

  const { headers } = useToken()

  const download = async () => {
    setFetching(true)
    const path = {
      filepath,
    }
    const presigned_url = await axios({
      method: 'post',
      url: `${process.env.NEXT_PUBLIC_API_URL}/download`,
      headers,
      data: path,
    }).then((res) => {
      const url = res.data
      if (!url) {
        setFetching(false)
        setToast({
          text: 'There was a problem downloading your file. If error persists, contact support@waterproplan.com',
          type: 'error',
          delay: 5000,
        })
        return
      }
      return url
    })

    fetch(presigned_url)
      .then((response) => response.blob())
      .then((blob) => {
        setFetching(false)
        const blobURL = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobURL
        a.style = 'display: none'

        if (filename && filename.length) a.download = filename
        document.body.appendChild(a)
        a.click()
      })
      .catch(() => {
        setFetching(false)
        setToast({
          text: 'There was a problem downloading your file. If error persists, contact support@waterproplan.com',
          type: 'error',
          delay: 5000,
        })
      })
  }

  return (
    <Button
      type="text"
      scale={0.5}
      disabled={fetching}
      onClick={download}
      aria-label="download proof of repair"
    >
      Download
    </Button>
  )
}
